import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';

const INACTIVITY_LIMIT_MS = 60 * 60 * 1000;
const CHECK_INTERVAL_MS = 60 * 1000;
const ACTIVITY_EVENTS = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'];

const clearVendorSession = () => {
  localStorage.removeItem('vendorToken');
  localStorage.removeItem('vendorData');
  localStorage.removeItem('vendorLastActivity');
  window.dispatchEvent(new Event('vendor-session-changed'));
};

export const SessionTimeoutManager = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const ensureActivityTimestamps = () => {
      const now = Date.now().toString();
      if (localStorage.getItem('token') && !localStorage.getItem('clientLastActivity')) {
        localStorage.setItem('clientLastActivity', now);
      }
      if (localStorage.getItem('vendorToken') && !localStorage.getItem('vendorLastActivity')) {
        localStorage.setItem('vendorLastActivity', now);
      }
    };

    const markActivity = () => {
      const now = Date.now().toString();
      if (localStorage.getItem('token')) {
        localStorage.setItem('clientLastActivity', now);
      }
      if (localStorage.getItem('vendorToken')) {
        localStorage.setItem('vendorLastActivity', now);
      }
    };

    const checkExpiry = () => {
      const now = Date.now();
      const clientToken = localStorage.getItem('token');
      const vendorToken = localStorage.getItem('vendorToken');
      const clientLastActivity = Number(localStorage.getItem('clientLastActivity') || 0);
      const vendorLastActivity = Number(localStorage.getItem('vendorLastActivity') || 0);

      if (clientToken && clientLastActivity && now - clientLastActivity > INACTIVITY_LIMIT_MS) {
        logout();
        toast.info('You were signed out after 60 minutes of inactivity.');
        if (['/admin', '/planner', '/dashboard'].some((path) => location.pathname.startsWith(path))) {
          navigate('/auth', { replace: true });
        }
      }

      if (vendorToken && vendorLastActivity && now - vendorLastActivity > INACTIVITY_LIMIT_MS) {
        clearVendorSession();
        toast.info('Vendor session ended after 60 minutes of inactivity.');
        if (location.pathname.startsWith('/vendor/dashboard')) {
          navigate('/vendor/auth', { replace: true });
        }
      }
    };

    ensureActivityTimestamps();
    checkExpiry();
    ACTIVITY_EVENTS.forEach((eventName) => window.addEventListener(eventName, markActivity, { passive: true }));
    const intervalId = window.setInterval(checkExpiry, CHECK_INTERVAL_MS);

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => window.removeEventListener(eventName, markActivity));
      window.clearInterval(intervalId);
    };
  }, [location.pathname, logout, navigate]);

  return null;
};